export const FIRM_DOCUMENT_PREVIEW_PANEL_TEST_IDS = {
  actions: 'firm-documents-preview-actions',
  closeAction: 'firm-documents-preview-close-action',
  copyAction: 'firm-documents-preview-copy-action',
  body: 'firm-documents-preview-body',
  deleteAction: 'firm-documents-preview-delete-action',
  downloadAction: 'firm-documents-preview-download-action',
  downloadFallbackAction: 'firm-documents-preview-download-fallback-action',
  expandAction: 'firm-documents-preview-expand-action',
  renameAction: 'firm-documents-preview-rename-action',
  metadata: 'firm-documents-preview-metadata',
  metadataChip: (key: string) => `firm-documents-preview-metadata-${key}`,
  root: 'firm-documents-preview-panel',
  title: 'firm-documents-preview-title',
} as const;
